module.exports = __webpack_public_path__ + "img/company.917c8210.png";